/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetVoicesByModelVersionResult } from '../../models/get-voices-by-model-version-result';

export interface ApiModelsVersionsModelVersionIdVoicesGet$Params {
  modelVersionId: string;
}

export function apiModelsVersionsModelVersionIdVoicesGet(http: HttpClient, rootUrl: string, params: ApiModelsVersionsModelVersionIdVoicesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetVoicesByModelVersionResult>> {
  const rb = new RequestBuilder(rootUrl, apiModelsVersionsModelVersionIdVoicesGet.PATH, 'get');
  if (params) {
    rb.path('modelVersionId', params.modelVersionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetVoicesByModelVersionResult>;
    })
  );
}

apiModelsVersionsModelVersionIdVoicesGet.PATH = '/api/Models/versions/{modelVersionId}/voices';
